import React from 'react';
import {Atom, Plugins} from '@packages/systems/wfdl';
import {iconName, qualify} from '@packages/systems/wfdl-Qualified';
import {TListOfElement} from '@packages/systems/wfdl-ast';
import {createIntegratedAtom} from '@packages/utilities/integrated-types';
import {EvaluatedNodeData, getChildren} from '@packages/utilities/data-utils';

const CommerceLayoutContainer = Atom.createRender(
  ({attributes, classes, data, generateAttributes, renderChild}) => {
    const commerceLayoutContainerClasses = classes.push(`w-container`);
    return (
      <div {...generateAttributes(attributes, commerceLayoutContainerClasses)}>
        {getChildren(data).map((child: EvaluatedNodeData) =>
          renderChild(child)
        )}
      </div>
    );
  }
);

const config = createIntegratedAtom({
  displayName: 'Container',
  showEmpty: true,
  icon: {
    type: 'Component',
    value: qualify(Plugins.name('Layout'), iconName('Container')),
  },
  style: {
    base: {
      main: {
        noPseudo: {
          display: 'flex',
          alignItems: 'flex-start',
          justifyContent: 'center',
        },
      },
      small: {
        noPseudo: {
          flexDirection: 'column',
          alignItems: 'stretch',
        },
      },
    },
  },
  render: CommerceLayoutContainer,
  fields: {children: TListOfElement},
});

export default config;
